import Commerce from "@chec/commerce.js";

export const commerce = new Commerce(
  process.env.REACT_APP_CHEC_SANDBOX_PUBLLIC_KEY,
  process.env.NODE_ENV === "development" // turn off debug mode in PROD
);
